export default __webpack_public_path__ + "beed20afbfefb3ec86936956dc95fc6c.svg";